import ApiService from "./api.service";
export default class HotelService extends ApiService {
    static async getDistanceToCityCenterInKm( latitude, longitude, axiosInstance, isPublic = false) {
        const response = await axiosInstance.get(`${this.base_url}/distance${isPublic ? "/public" : ""}/${latitude}/${longitude}`);
        return response.data;
    }
    static base_url = `${super.base_url}/hotels`;
}
